<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/btRwPx/media/FC-9781398486478.jpg?1692049823896" alt="This image is the cover for the book Blood and Guilt"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Blood and Guilt
      </h1>
      <p class="bookDescription body article font2">
        <p>He remained a myth throughout his life – almost a horror story. To many just a rumour, and to others, UK’s most feared gangster! Nobody knew him. Now it was his turn to tell his story and expose several truths regarding organised crime and corruption. But how much can he reveal – how much can we believe? A life of blood, fear and regret compiled with a search for understanding and empathy. Is he looking for forgiveness? Or does he only have a tale to tell? We’ve all read about villains – hard men. It has captivated us, shocked us and in some cases inspired us, but in this book, Paul Reddy looks to educate and inform us, and to a lesser extent, looks to entertain us too. The shocking story of Britain's most infamous gangster in his own words!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Burton
      </h2>
      
      <p class="authorDescription body article">David Burton has lived in County Durham all of his life and was schooled and educated there also. He has a passion and desire for stories and storytelling. From reading to films and later to writing. A desire to turn the most simplistic situation and character into a tale; to create heroes and villains from the ordinary. David still regards himself as being in continuous education.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8c071996